import { defineComponent as A, ref as f, computed as i, watch as y, createElementBlock as m, openBlock as v, normalizeClass as s, createElementVNode as h, Fragment as S, renderList as W, normalizeStyle as _, createCommentVNode as $, createVNode as j, unref as V } from "vue";
import { RevIllustration as E } from "@ds/components/Illustration";
import { tw as e } from "../../../utils/tailwind.js";
const P = ["aria-current", "aria-label", "onClick"], q = /* @__PURE__ */ A({
  name: "RevCarouselController",
  __name: "CarouselController",
  props: {
    buttonAriaLabel: {},
    currentIndex: {},
    intervalProgression: { default: 0 },
    autoplayRunning: { type: Boolean, default: !1 },
    imageCount: {},
    thumbnails: { default: () => [] },
    shouldThumbnailsScroll: { type: Boolean, default: !1 },
    prevButtonRef: { default: void 0 }
  },
  emits: ["select"],
  setup(w, { emit: C }) {
    const a = w, R = C, c = f({
      stateChanged: !1,
      iterations: 0
    });
    function r(t) {
      return t === a.currentIndex;
    }
    const d = i(
      () => a.thumbnails.length === a.imageCount
    );
    function T(t) {
      if (d.value) return e`focus-visible-outline-default-hi rounded-sm`;
      if (!a.autoplayRunning)
        return e`focus-visible-outline-default-hi rounded-sm size-8`;
      if (!r(t))
        return e`focus-visible-outline-default-hi rounded-sm relative size-8 items-center overflow-hidden`;
      const o = t === 0 && c.value.stateChanged && c.value.iterations === 0, u = t !== 0 || c.value.iterations > 0;
      return [
        e`bg-action-default-low focus-visible-outline-default-hi rounded-lg relative h-8 w-32 cursor-pointer items-center overflow-hidden
    border hover:bg-action-default-low-hover`,
        o && e`transition-width duration-300`,
        u && e`animate-fast-expand-translate-x-backwards transition-width duration-300`
      ];
    }
    function I(t) {
      if (!d.value && r(t) && a.autoplayRunning)
        return `width: ${a.intervalProgression * 100}%`;
    }
    const n = f(null), b = i(() => n.value?.children?.[a.currentIndex]), L = i(() => [
      a.shouldThumbnailsScroll && e`gradient-mask-lr-60 absolute inset-x-0`
    ]), k = i(() => (t) => {
      const o = d.value, u = r(t);
      return [
        e`appearance-none overflow-hidden no-underline transition-colors motion-reduce:transition-none`,
        !o && a.autoplayRunning && e`absolute`,
        r(t) && e`-inset-y-1 left-0`,
        !o && e`border-action-default-hi rounded-full size-8 border`,
        !o && u && e`bg-action-default-mid-pressed hover:bg-action-default-mid-hoverpressed`,
        !o && !u && e`bg-action-default-low hover:bg-action-default-low-hover`,
        o && e`bg-action-default-low rounded-sm flex size-40 justify-center border border-solid`,
        o && !u && e`border-action-default-low`,
        o && u && e`border-action-default-low-pressed`
      ];
    }), B = i(() => (t) => [
      e`flex`,
      !r(t) && e`opacity-50 hover:opacity-100 focus:opacity-100`
    ]), N = i(() => [
      e`flex list-none flex-row gap-8 overflow-hidden py-4`,
      a.shouldThumbnailsScroll ? e`justify-normal` : e`justify-center`,
      !d.value && e`-mx-4 p-4`
    ]), p = f(0), g = f(0);
    function x() {
      n.value !== null && (a.shouldThumbnailsScroll ? (p.value = a.prevButtonRef instanceof HTMLElement ? a.prevButtonRef.offsetWidth : 48, n.value.style.paddingLeft = `${p.value + 8}px`, n.value.style.paddingRight = `${p.value + 8}px`, g.value = b.value && b.value.offsetLeft + b.value.offsetWidth / 2 - n.value.offsetWidth / 2 || 0, n.value.scrollTo !== void 0 && n.value.scrollTo({
        left: g.value,
        behavior: "smooth"
      })) : (n.value.style.paddingLeft = "4px", n.value.style.paddingRight = "4px", n.value.style.marginRight = "-4px", n.value.style.marginLeft = "-4px"));
    }
    y(
      () => [a.currentIndex, a.shouldThumbnailsScroll],
      () => {
        x(), a.currentIndex === a.imageCount - 1 && (c.value.iterations += 1);
      }
    ), y(
      () => a.autoplayRunning,
      () => {
        c.value.stateChanged = !0;
      }
    );
    function z(t) {
      return `${a.buttonAriaLabel} ${t + 1}`;
    }
    return (t, o) => (v(), m("div", {
      class: s(L.value)
    }, [
      h("ul", {
        ref_key: "thumbnailsRef",
        ref: n,
        class: s(N.value)
      }, [
        (v(!0), m(S, null, W(t.imageCount, (u, l) => (v(), m("li", {
          key: l,
          class: "flex"
        }, [
          h("div", {
            class: s({ "w-32": r(l) && t.autoplayRunning })
          }, [
            h("button", {
              "aria-current": r(l),
              "aria-label": z(l),
              class: s(["flex", T(l)]),
              type: "button",
              onClick: () => R("select", l)
            }, [
              h("div", {
                class: s(k.value(l)),
                style: _(I(l))
              }, [
                d.value ? (v(), m("span", {
                  key: 0,
                  class: s(B.value(l))
                }, [
                  j(V(E), {
                    alt: t.thumbnails[l].alt,
                    class: "!h-40 object-cover",
                    height: 40,
                    sizes: "40px",
                    src: t.thumbnails[l].src,
                    width: 40
                  }, null, 8, ["alt", "src"])
                ], 2)) : $("", !0)
              ], 6)
            ], 10, P)
          ], 2)
        ]))), 128))
      ], 2)
    ], 2));
  }
});
export {
  q as default
};
